import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import {  WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import WebDesigner from "../WebDesigner";

export default class BusinessHero extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessHero;
        this.displayName = "Address Image";
        this.dropList = defaultDropList;
        this.editList = [ ...CreateAttributeList(false,false,false,true,false,false,true)];
        this.contentEditable = false;
        this.icon = (
            <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 576 512"><path d="M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l19.8 0 80.8-110.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L232.8 330l83.1-127.1c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L485 400l27 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM96 448l-32 0c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-40 0-200 0-72 0L96 448zm64-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>)

    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, "");
        const atts = GetNodeDomAttributes("vb-control v-hero max-100 w-full", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="hero" layout={layout} classNames={atts.className} />
        }
        return (
            <Fragment>
                <div {...atts}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="hero" node={component} userContext={siteData} />
                </div>
            </Fragment>
        )
    }
}
